import { Box, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import Link from 'next/link';
import TeeTimeIcon from '../../../public/assets/home.svg';
import HomeIcon from '../../../public/assets/home.svg';
import ShopIcon from '../../../public/assets/shop.svg';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: '0px 80px',
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(350px, auto))',
    gap: '32px',
  },
  parent: {
    display: 'flex',
    flex: '1',
    flexDirection: 'column',
  },
  headlineContainer: {
    display: 'flex',
    alignItems: 'center',
    height: '50px',
    paddingLeft: '20px',
    marginBottom: '24px',
    backgroundColor: '#F8F3E6',
    borderRadius: '0px 365px 365px 0px',
    margin: '0px',
    cursor: 'pointer',
  },
  headline: {
    color: '#212121',
    fontFamily: 'Playfair Display',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '27px',
    margin: '0px',
  },
  child: {
    paddingLeft: '20px',
    cursor: 'pointer',
  },
  childLink: {
    textDecoration: 'none',
  },
  title: {
    color: '#212121',
    fontFamily: 'Playfair Display',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '27px',
    margin: '0px',
  },
  description: {
    color: '#212121',
    fontFamily: 'Lato',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '22px',
    margin: '0px',
  },
  actionContainer: {
    width: '100%',
    padding: '0px 80px',
    display: 'flex',
    gap: '32px',
    paddingTop: '23px',
    marginTop: '31px',
    paddingBottom: '20px',
    backgroundColor: '#F8F8F8',
  },
  actionLink: {
    cursor: 'pointer',
    display: 'flex',
  },
}));

function HoverDropdownMenu({ activeId, setActiveInnerItem, menu }) {
  const selectedItems = Object.entries(menu[activeId].below).map(
    ([key, item], i) => {
      const below = {
        ...item,
        below: Object.entries(item.below).map(([_, e]) => ({
          ...e,
          description: Object.entries(e.below).map(([_, d]) => d)[0].title,
        })),
      };
      return below;
    }
  );

  const showCallActions =
    Object.entries(menu).findIndex(([key]) => activeId === key) === 2;

  const innerItems = [
    // will be removed in future updates
    {
      id: 1,
      dropdownMenu: [
        {
          id: 1,
          title: 'Live & Play at Baywood',
          url: `${window.location.origin}/living`,
          below: [
            {
              title: 'Home Sales',
              description: 'Receive a guided tour of the Baywood community.',
              url: `${window.location.origin}/living/homes`,
            },
            {
              title: 'Golf Experience ',
              description:
                'The most visually spectacular golf course in Delaware.',
              url: `${window.location.origin}/golf`,
            },
            {
              title: 'Golf Programs',
              description: 'We have programs for all ages and skill level.',
              url: `${window.location.origin}/programs`,
            },
          ],
        },
        {
          id: 2,
          title: 'Amenities ',
          url: `${window.location.origin}/living/amenities`,
          below: [
            {
              title: 'Beaches & Marinas',
              description: 'Access to private inland bay, beaches and marina.',
              url: `${window.location.origin}/living/amenities/beaches-marina`,
            },
            {
              title: 'Pool & Tennis',
              description:
                'Enjoy other activities such as tennis and swimming.',
              url: `${window.location.origin}/living/amenities/pool-tennis`,
            },
            {
              title: 'Community Center',
              description:
                'Private access to the Community Center at the pool.',
              url: `${window.location.origin}/living/baywood-community-center`,
            },
          ],
        },
        {
          id: 3,
          title: 'Why Baywood',
          url: `${window.location.origin}/living/why-choose-baywood`,
          below: [
            {
              title: 'Our Team',
              description: 'Here to assist you with any questions you have.',
              url: `${window.location.origin}/living/our-team`,
            },
            {
              title: 'Benefits',
              description: 'Find the benefits for being a Baywood member.',
              url: `${window.location.origin}/location/what-are-benefits-land-lease-community`,
            },
            {
              title: 'Site Plan',
              description: 'See how Baywood is laid out.',
              url: `${window.location.origin}/baywood-greens-site-plan`,
            },
          ],
        },
      ],
    },
    {
      id: 2,
      dropdownMenu: [
        {
          id: 1,
          title: 'Home Sales',
          url: `${window.location.origin}/living/homes`,
          below: [
            {
              title: 'Home Sales',
              description: 'Receive a guided tour of the Baywood community.',
              url: `${window.location.origin}/living/homes`,
            },
            {
              title: 'Floor Plans',
              description: 'Build your dream home at Baywood Greens.',
              url: `${window.location.origin}/living/homes/floorplans`,
            },
            {
              title: 'New Homes',
              description: 'New single-family built with the latest designs.',
              url: `${window.location.origin}/living/homes/new`,
            },
            {
              title: 'Pre-Owned Homes',
              description: 'Beautiful pre-owned home in Long Neck Delaware.',
              url: `${window.location.origin}/living/homes/pre-owned`,
            },
          ],
        },
        {
          id: 2,
          title: 'Live & Play ay Baywood',
          url: `${window.location.origin}/living`,
          below: [
            {
              title: 'Amenities',
              description: 'What our community offers.',
              url: `${window.location.origin}/living/amenities`,
            },
            {
              title: 'Golf Experience',
              description:
                'The most visually spectacular golf course in Delaware.',
              url: `${window.location.origin}/golf`,
            },
            {
              title: 'Why Baywood',
              description: 'Enjoy the beautiful community of Baywood.',
              url: `${window.location.origin}/living/why-choose-baywood`,
            },
          ],
        },
      ],
    },
    {
      id: 3,
      dropdownMenu: [
        {
          id: 1,
          title: 'Golf Experience',
          url: `${window.location.origin}/golf`,
          below: [
            {
              title: 'Pro Instructions',
              description:
                'Here to ensure game improvement for all golf levels.',
              url: `${window.location.origin}/golf/pro-shop/golf-instruction`,
            },
            {
              title: 'Score Card',
              description: 'Download our score card and get on the course.',
              url: `${window.location.origin}/golf/pro-shop/course-scorecard`,
            },
            {
              title: 'Hours & Information',
              description: 'Daily course conditions and information.',
              url: `${window.location.origin}/golf/pro-shop/hours-and-information`,
            },
          ],
        },
        {
          id: 2,
          title: 'Programs',
          url: `${window.location.origin}/programs`,
          below: [
            {
              title: 'Private Golf Course',
              description: 'Every Wednesday at 9AM with our gold experts.',
              url: `${window.location.origin}/programs/private-lessons`,
            },
            {
              title: 'Club Fitting',
              description: 'Improve your game with your club choice.',
              url: `${window.location.origin}/programs/club-fitting`,
            },
            {
              title: 'Junior Programs',
              description: 'Ready for young golfers to learn essential skills.',
              url: `${window.location.origin}/programs/junior-programs`,
            },
            {
              title: 'Women`s Programs',
              description: 'We have classes for all levels of woman golfers.',
              url: `${window.location.origin}/programs/women-programs`,
            },
            {
              title: 'Adult Classes',
              description: 'Learn new skills or improve old ones.',
              url: `${window.location.origin}/programs/adult-classes`,
            },
          ],
        },
      ],
    },
  ];

  const menuCallActions = [
    {
      id: 1,
      title: 'Book a Tee Time',
      description: 'Ready to hit the course? Find a time that works. ',
      icon: <TeeTimeIcon />,
      url: `${window.location.origin}/golf/tee-times`,
    },
    {
      id: 2,
      title: 'Stay & Play Packages',
      description: 'Tailored gold packages to make your stay enjoyable.',
      icon: <HomeIcon />,
      url: `${window.location.origin}/golf/packages`,
    },
    {
      id: 3,
      title: 'Pro Shop & Apparel',
      description: 'Find gift cards, comfortable gold clothes and more. ',
      icon: <ShopIcon />,
      url: `${window.location.origin}/golf/pro-shop`,
    },
  ];
  const classes = useStyles();

  return (
    <Box style={{ width: '100%' }}>
      <Box className={classes.container}>
        {selectedItems.map((item, index) => (
          <Box
            className={classes.parent}
            style={
              activeId === 2 || activeId === 3
                ? {
                    flex:
                      activeId === 2 && item.id == 1
                        ? 1
                        : activeId === 3 && item.id === 2
                        ? 1
                        : 'unset',
                  }
                : {}
            }
            key={`dropdown-${index}`}
          >
            <MenuHeadline headline={item.title} url={item.url} />
            <Box
              style={{
                gap: '24px',
                display: 'grid',
                gridAutoFlow: 'column',
                gridTemplateRows: 'repeat(3, auto)',
                gridTemplateColumns:
                  item.below.length > 3 ? 'repeat(2, 1fr)' : '1fr',
                gridAutoRows:
                  item.below.length > 3 ? 'repeat(3, 1fr)' : 'unset',
                flexDirection: 'column',
              }}
            >
              {item.below.map((variant, index) => (
                <Box
                  className={classes.child}
                  style={variant.title === 'Pre-Owned Homes' ? {} : {}}
                  key={`variant-${index}`}
                >
                  <Link
                    href={`${window.location.origin}${variant.url}`}
                    passHref
                  >
                    <a
                      className={classes.childLink}
                      onClick={() => setActiveInnerItem(null)}
                    >
                      <Typography className={classes.title}>
                        {variant.title}
                      </Typography>
                    </a>
                  </Link>
                  <Typography className={classes.description}>
                    {variant.description}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        ))}
      </Box>
      {showCallActions && (
        <Box className={classes.actionContainer}>
          {menuCallActions.map((item, index) => (
            <Link href={item.url} key={index} passHref>
              <a
                className={classes.childLink}
                onClick={() => setActiveInnerItem(null)}
              >
                <Box
                  key={`menu-call-action-${item.id}`}
                  className={classes.actionLink}
                >
                  <Box
                    style={{
                      paddingRight: '14px',
                    }}
                  >
                    {item.icon}
                  </Box>
                  <Box>
                    <Typography className={classes.title}>
                      {item.title}
                    </Typography>
                    <Typography className={classes.description}>
                      {item.description}
                    </Typography>
                  </Box>
                </Box>
              </a>
            </Link>
          ))}
        </Box>
      )}
    </Box>
  );
}

export default HoverDropdownMenu;

function MenuHeadline({ headline, url }) {
  const classes = useStyles();

  return (
    <Link href={url} passHref>
      <Box className={classes.headlineContainer}>
        <Box>
          <Typography className={classes.headline}>{headline}</Typography>
        </Box>
        <div
          style={{
            marginLeft: '10px',
            height: 18,
            width: 24,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="18"
            viewBox="0 0 24 16"
            fill="none"
          >
            <path
              d="M23.7071 8.70711C24.0976 8.31658 24.0976 7.68342 23.7071 7.29289L17.3431 0.928932C16.9526 0.538408 16.3195 0.538408 15.9289 0.928932C15.5384 1.31946 15.5384 1.95262 15.9289 2.34315L21.5858 8L15.9289 13.6569C15.5384 14.0474 15.5384 14.6805 15.9289 15.0711C16.3195 15.4616 16.9526 15.4616 17.3431 15.0711L23.7071 8.70711ZM0 9H23V7H0V9Z"
              fill="#2A5931"
            />
          </svg>
        </div>
      </Box>
    </Link>
  );
}
